import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { LoginForm } from "./LoginForm";

interface AuthDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function AuthDialog({ open, onOpenChange }: AuthDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[calc(100vh-40px)] w-[calc(100vw-28px)] max-w-[500px] gap-0 overflow-y-auto border border-white/80 bg-white p-0 shadow-[0_18px_56px_rgba(15,23,42,0.10)] dark:border-white/10 dark:bg-neutral-950 dark:shadow-[0_24px_80px_rgba(0,0,0,0.40)] sm:rounded-[22px]">
        <DialogTitle className="sr-only">Sign in to Zapify</DialogTitle>
        <LoginForm surface="modal" />
      </DialogContent>
    </Dialog>
  );
}
